import React from 'react';
const FullScreenLoader = ({ message = 'Initialisation...' }) => {
  const logoSrc = '/logoMuzo.svg';
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-slate-950 text-white animate-in fade-in duration-300">
      <div className="relative flex flex-col items-center gap-8">
        {/* Logo Container */}
        <div className="relative">
            {/* Glow effect */}
            <div className="absolute -inset-4 rounded-full bg-indigo-500/20 blur-xl animate-pulse"></div>
            
            {/* Icon */}
            <div className="relative flex h-20 w-20 items-center justify-center rounded-2xl bg-gradient-to-br from-indigo-600 to-violet-600 shadow-2xl shadow-indigo-500/30 ring-1 ring-white/10 overflow-hidden">
                <img src={logoSrc} alt="Muzo Studio" className="w-12 h-12 object-contain" />
            </div>
            
            {/* Corner accents */}
            <div className="absolute -top-1 -right-1 h-3 w-3 rounded-full bg-white/20 backdrop-blur-sm"></div>
            <div className="absolute -bottom-1 -left-1 h-2 w-2 rounded-full bg-white/10 backdrop-blur-sm"></div>
        </div>
        
        {/* Text Content */}
        <div className="flex flex-col items-center gap-3">
            <h1 className="text-2xl font-bold tracking-tight bg-gradient-to-r from-white to-slate-400 bg-clip-text text-transparent">
                Muzo Studio
            </h1>
            
            <div className="flex items-center gap-3 rounded-full bg-white/5 px-4 py-1.5 ring-1 ring-white/10 backdrop-blur-sm">
                <div className="relative flex h-2.5 w-2.5">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-indigo-500"></span>
                </div>
                <span className="text-xs font-medium text-slate-300 tracking-wide">{message}</span>
            </div>
        </div>
      </div>
      
      {/* Footer */}
      <div className="absolute bottom-8 text-[10px] text-slate-600 uppercase tracking-widest font-semibold">
        Chargement de l'expérience
      </div>
    </div>
  );
};

export default FullScreenLoader;
